/**
 * Bold Inline Tool for Editor.js
 * Adds <strong> formatting to selected text
 */
export default class BoldTool {
  static get isInline() {
    return true;
  }

  constructor({ api }) {
    this.api = api;

    // Create the button
    this.button = document.createElement('button');
    this.button.innerHTML = '<b>B</b>';
    this.button.classList.add(this.api.styles.inlineToolButton);
  }

  /**
   * Returns the button element for the inline tool
   */
  render() {
     this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.innerHTML = '<b>B</b>';
    this.button.classList.add(this.api.styles.inlineToolButton);
    return this.button;
  }

  /**
   * Called when user clicks the button
   */
  surround(range) {
    if (!range) return;

    const selectedText = range.extractContents();
    const strong = document.createElement('strong');
    strong.appendChild(selectedText);
    range.insertNode(strong);

    this.api.selection.expandToTag(strong);
  }

  /**
   * Check if selection contains a <strong> tag
   */
  checkState(selection) {
    const anchor = selection.anchorNode;
    if (!anchor) return;

    const strongTag = this.api.selection.findParentTag('STRONG', BoldTool.tag);
    this.button.classList.toggle(this.api.styles.inlineToolButtonActive, !!strongTag);
  }

  /**
   * Sanitizer config to keep <strong> tags
   */
  static get sanitize() {
    return {
      strong: {},
    };
  }
}

BoldTool.tag = 'STRONG';